export default __webpack_public_path__ + "static/media/mokap.bd825815.svg";